import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import union from "lodash/union";

import { hydrate } from "@/lib";
import { fetchRecommendations } from "./thunk";

export interface RecommendationsState {
  error: string | null;
  status: "idle" | "fetching" | "saving";
  recommendations: Array<any>;
  meta: { count: number };
  page: number;
}

const initialState: RecommendationsState = {
  error: null,
  status: "idle",
  recommendations: [],
  meta: { count: null },
  page: 1
};

export const recommendationsSlice = createSlice({
  name: "recommendations",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(hydrate, (state, action: PayloadAction<string>) => {
        return {
          ...state,
          ...action.payload[recommendationsSlice.name]
        };
      })
      .addCase(fetchRecommendations.pending, (state) => {
        state.status = "fetching";
      })
      .addCase(fetchRecommendations.fulfilled, (state, action) => {
        const { meta, recommendations } = action.payload;

        state.status = "idle";
        state.meta = meta;
        state.recommendations = union(state.recommendations, recommendations);
        state.page = recommendations.length ? state.page + 1 : state.page;
      })
      .addCase(fetchRecommendations.rejected, (state, action) => {
        state.status = "idle";
        state.error = action.error.message;
      });
  }
});
